module.exports = __webpack_public_path__ + "static/media/bretagne.3468d2b7.jpg";